export const INTRO_PARAGRAPHS = [
  'These metrics show the current distribution of approved active placements by placement type and multi-type combinations.',
  'Approved Active Placements include those in the following statuses: Approved TWP, Associate Decision Pending, TWP but Pending Updated Restrictions, or Indefinite Restrictions status.',
];

export const METRIC_DEFINITIONS = [
  { term: 'Total Placements', definition: 'All approved active placements matching your current selections.' },
  {
    term: 'Process Path (Unmodified)',
    definition: 'Standard process path, no job modifications. The most preferred placement type.',
  },
  {
    term: 'Process Path (Modified)',
    definition:
      'Process path with one or more job modifications applied. Second in priority, still a process-path outcome.',
  },
  {
    term: 'Temporary Light Duty (TLD)',
    definition:
      'Placement outside standard operational roles (i.e., not a position the business would hire into or otherwise staff as part of normal business operations). Least preferred and a last resort.',
  },
  {
    term: 'Multi-Job Type',
    definition:
      'Associates assigned to more than one placement type at the site (any combination across unmodified, modified, or TLD).',
  },
];
